export default () => {
  Chaplin.Model.prototype.property = function(value, callback) {
    if(this.has(value)) {
      return callback(this.get(value));
    }
  };

  $(document).ajaxError(function (e, xhr, options) {
    if(window.parent) {
      window.parent.postMessage({ event_type: 'request:failed', status: xhr.status, location: xhr.getResponseHeader('location') }, '*');
    }
  });

  /**
   *  Shim fetch to add the language code as an Accept-Language header from i18next
   *    also see app/lib/utils.js for similar jQuery shim
  **/
  window.fetch = (function(original) {
    return function(...args) {
      if (i18next.language) {
        if (args[1] && args[1].headers) {   // if a config object with headers is found
          if (args[1].headers instanceof Headers) {
            const acceptLanguage = args[1].headers.get('Accept-Language');

            args[1].headers.set(  // merge the language code from i18next with the existing Accept-Language header
              'Accept-Language', `${i18next.language};q=1.0${acceptLanguage ? ',' + acceptLanguage : ''}`
            );
          } else {
            const acceptLanguage = args[1].headers['Accept-Language'];
            args[1].headers['Accept-Language'] = `${i18next.language};q=1.0${acceptLanguage ? ',' + acceptLanguage : ''}`;
          }
        } else {                                               // if no config object is found
          const headers = new Headers();
          headers.set('Accept-Language', `${i18next.language};q=1.0`);
          const config = args[1] ? args[1] : {};
          config.headers = headers;
          const arg = args.shift();                            // preserve the first argument
          args.unshift(config);                                // add new/updated config object
          args.unshift(arg);                                   // restore the first argument so headers is the second argument
        }
      }
      return original.apply(this, args).then(function(response) {
        if(response.status !== undefined && response.status !== 200)
        {
          if(window.parent) {
            window.parent.postMessage({ event_type: 'request:failed', status: response.status, location: response.headers.get('location')}, '*');
          }
        }
        return response;
      });
    };
  })(window.fetch);
};
